import { SICKNESS, DISPLACEMENT } from '../constants';
import { HR_ERRORS } from '../constants.errors';
import { isUndefinedOrNullOrEmpty } from '../../utils/isUndefinedOrNullOrEmpty';

export class Request {

  constructor(type) {
    this.type = type;
  }

  static get TYPES() {
    return {
      VACATION  : 'vacation',
      ABSENCE   : 'absence',
      HOLIDAY : 'holiday'
    };
  }

  static get STATUS() {
    return {
      APPROVED  : 'approved',
      REQUESTED : 'requested',
      DELETED   : 'deleted'
    };
  }

  static get STATUS_REQUESTED() {
    return {
      APPROVE  : 'approve',
      DELETE   : 'delete',
      DISCARD  : 'discard'
    };
  }

  static get ACTIONS() {
    return {
      APPROVE  : 'approve',
      REJECT   : 'reject'
    };
  }

  static getTranslation(key) {
    const TRANSLATIONS = {};
    TRANSLATIONS[this.TYPES.VACATION] = 'VACATIONS_ABSENCES.GENERAL.VACATIONS';
    TRANSLATIONS[this.TYPES.ABSENCE]  = 'VACATIONS_ABSENCES.GENERAL.ABSENCES';
    TRANSLATIONS[this.STATUS_REQUESTED.DELETE]  = 'GLOBALS.CANCELLATION';
    TRANSLATIONS[this.STATUS_REQUESTED.DISCARD]  = 'GLOBALS.NOTIFICATION';

    if (isUndefinedOrNullOrEmpty(TRANSLATIONS[key])) {
      return HR_ERRORS.DEFAULT_VISIBLE_TEXT;
    }

    return TRANSLATIONS[key];
  }

  static isVacation(request) {
    return request.type === this.TYPES.VACATION;
  }

  static isSick(request) {
    return SICKNESS.CODES.indexOf(request.code) > -1;
  }

  static isDisplacement(request) {
    return DISPLACEMENT.CODES.indexOf(request.code) > -1;
  }

  static isFinishedSick(request) {
    return this.isSick(request) && !request.forcedEndDate;
  }

  static isApproved(request) {
    return request.status === this.STATUS.APPROVED;
  }

  static isRequested(request) {
    return request.status === this.STATUS.REQUESTED;
  }

  static isDeleted(request) {
    return request.status === this.STATUS.DELETED;
  }

  static isHourly(request) {
    return request.hours !== undefined && request.hours !== null && request.hours > 0;
  }
}



// WEBPACK FOOTER //
// ./client/app/common/domain/models/request.js